export default __webpack_public_path__ + "static/play-723f6e607cba36fcde6e17803f79c9ca.png";